import { component$, useStyles$, type PropFunction } from "@builder.io/qwik";
import { cn } from "../../utils/tailwind-helper";

export interface AutoplayButtonProps {
    isAutoPlaying: { value: boolean };
    activeSlideIndex: { value: number };
    transitionState: { value: string };
    AUTOPLAY_SPEED: number;
    onToggleAutoplay$: PropFunction<() => void>;
    buttonClassName?: string;
    innerSVGClassName?: string;
}

export const AutoplayButton = component$<AutoplayButtonProps>(
    ({ isAutoPlaying, activeSlideIndex, transitionState, AUTOPLAY_SPEED, onToggleAutoplay$, buttonClassName = "", innerSVGClassName="" }) => {
        const commonButtonStyles =
            "text-white w-10 h-10 flex items-center justify-center rounded-full bg-black-opacity-20 backdrop-blur-md hover:bg-black-opacity-30";

        useStyles$(
            `
            @keyframes progress-circle {
                from {
                    stroke-dashoffset: 122.5;
                }
                to {
                    stroke-dashoffset: 0;
                }
            }
        
            .animate-progress-circle {
                animation: progress-circle linear 1;
            }
            `,
        );

        return (
            <button
                class={cn(
                    commonButtonStyles,
                    "relative border border-transparent transition-colors duration-200",
                    !isAutoPlaying.value && "border-white-opacity-20",
                    buttonClassName,
                )}
                style={{pointerEvents: "all"}}
                onClick$={onToggleAutoplay$}
            >
                {/* Progress Spinner */}
                {isAutoPlaying.value && (
                    <span class={cn("absolute inset-0 flex items-center justify-center")}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41 41" class="h-10 w-10">
                            {/* Background circle */}
                            <circle
                                cx="20.5"
                                cy="20.5"
                                r="19.5"
                                fill="none"
                                stroke="rgba(255,255,255,0.2)"
                                stroke-width="1.5"
                            />

                            {/* Animated progress arc */}
                            <path
                                key={`progress-${activeSlideIndex.value}`}
                                d="M 20.5 1 A 19.5 19.5 0 0 1 20.5 40 A 19.5 19.5 0 0 1 20.5 1"
                                fill="none"
                                stroke="white"
                                stroke-width="1"
                                stroke-linecap="round"
                                stroke-dasharray="122.5"
                                stroke-dashoffset="122.5"
                                class={cn(transitionState.value !== "TRANSITIONING" && "animate-progress-circle")}
                                style={{
                                    animationDuration: `${AUTOPLAY_SPEED}ms`,
                                }}
                            ></path>
                        </svg>
                    </span>
                )}
                <div class={cn(innerSVGClassName, " flex items-center justify-center")}>
                {isAutoPlaying.value ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none">
                        <rect width="2" height="12" rx="1" fill="currentColor" />
                        <rect x="8" width="2" height="12" rx="1" fill="currentColor" />
                    </svg>
                ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                            d="M6 4v12l10-6-10-6z"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                )}
                </div>

            </button>
        );
    },
);
